import PortalIdParser from 'PortalIdParser';
const getPersonalizationUrl = () => `/personalization/${PortalIdParser.get()}`;
export const isVariantEditorUrl = url => url.includes(`${getPersonalizationUrl()}/variants/`);
export const getVariantsEditorUrl = (strategyId, {
  full = true
} = {}) => full ? `${getPersonalizationUrl()}/variants/${strategyId}` : `/variants/${strategyId}`;